import { Observable } from 'rxjs';
import { distinctUntilChanged, filter, map, take } from 'rxjs/operators';

/*
 * Emits once when the loading becomes false (i.e. everything is loaded).
 * Automatically skips repeated false values.
 */
export function onceAllLoaded(loading$: Observable<boolean>): Observable<void> {
  return loading$.pipe(
    distinctUntilChanged(),
    filter((loaded) => !loaded),
    take(1),
    map(() => void 0)
  );
}
